// M128 G5 — SchedulerStatusLine (standalone module).
//
// Rustige B1-NL statusregel per Google-connector. Leest UITSLUITEND uit
// de bestaande `/auth/google/services/status`-response (velden
// `last_run_at`, `next_run_at`, `last_run_outcome`, `last_error_reason_nl`,
// `last_successful_report.fetched_at`, `interval_hours`). Geen aparte
// fetch, geen frontend-berekening van intervallen. Wordt in
// `PrivacyVaultPage.jsx` in elk van de Google-boxes (Ads/GA4/GSC) gerenderd.
//
// Extraheerd naar eigen bestand zodat de Jest-testsuite deze component kan
// renderen zonder `AppLayout` (en dus `react-router-dom`) mee te trekken —
// pre-existing Jest-resolver-issue omzeild zoals afgesproken.

import { formatFetchedAt } from "@/utils/formatFetchedAt";

export function SchedulerStatusLine({ svc, testid }) {
  if (!svc) return null;
  const outcome = svc.last_run_outcome;
  const nextAt = svc.next_run_at;
  const lastRunAt = svc.last_run_at;
  const lastOk = svc.last_successful_report?.fetched_at;
  const tz = "Europe/Amsterdam";
  const fmt = (iso) => iso ? formatFetchedAt(iso, tz) : null;

  // NLV-fix: outcome==="ok" moet renderen ook zonder `last_successful_report`
  // (import_schedule.last_run_at is voldoende bewijs van succes; het aparte
  // last_successful_report-veld op de connection was verwarrend leeg).
  const okStamp = lastOk || lastRunAt;
  let line = null;
  if (outcome === "grant_revoked") {
    line = "Koppeling verlopen — opnieuw koppelen om automatisch bijwerken te hervatten.";
  } else if (outcome === "api_disabled" || outcome === "provider_blocked") {
    line = `Automatisch dagelijks bijwerken. Laatste goede gegevens: ${fmt(lastOk) || "nog geen"}. Wachten op activering.`;
  } else if (outcome === "ok" && okStamp) {
    line = `Automatisch dagelijks bijwerken. Laatst gelukt: ${fmt(okStamp)}. Volgende poging: ${fmt(nextAt) || "planning nog niet gestart"}.`;
  } else if (outcome && outcome !== "ok" && lastOk) {
    line = `Automatisch dagelijks bijwerken. Laatste goede gegevens: ${fmt(lastOk)}. Volgende poging: ${fmt(nextAt) || "planning nog niet gestart"}.`;
  } else if (!lastRunAt && !lastOk && nextAt) {
    line = "Automatisch dagelijks bijwerken staat aan. Eerste ophaalpoging volgt binnenkort.";
  }
  if (!line) return null;
  return (
    <div className="text-[10px] text-text-subtle mt-1 leading-snug"
         data-testid={testid || "scheduler-status-line"}>
      {line}
    </div>
  );
}
